import commonUtil from "../../../../../../utils/commonUtil";

export const SAVE_EVENT_NAME = 'SAVE_EVENT_NAME';
export const SAVE_EVENT_NAME_SUCCESS = 'SAVE_EVENT_NAME_SUCCESS';
export const SAVE_EVENT_NAME_FAIL = 'SAVE_EVENT_NAME_FAIL';

export const VALIDATE_EVENT_NAME = 'VALIDATE_EVENT_NAME';
export const VALIDATE_EVENT_NAME_SUCCESS = 'VALIDATE_EVENT_NAME_SUCCESS';
export const VALIDATE_EVENT_NAME_FAIL = 'VALIDATE_EVENT_NAME_FAIL';

const GETVALIDATEEVENTNAMEURL = '/api/EventCreation/validateEventName';
const SAVEEVENTNAME = '/api/EditEvent/saveEventName';

// For Save Event Name
export function saveEventName(requestBody) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = requestBody.eventId;
  payload.eventName = requestBody.eventName;
  payload.imageUrl = requestBody.imageURL;
  payload.eventTheme= requestBody.eventTheme;
  payload.eventBackground= requestBody.eventBackground;
  payload.comment= requestBody.comment;

  return commonUtil.triggerServerRequest({ url: SAVEEVENTNAME, method: 'POST', data: payload });
}

export function handleSaveEventName(newEventName) {
  return {
    type: SAVE_EVENT_NAME,
    payload: newEventName,
  };
}

// For Validate Event Name
export function handleValidateEventName(eventName, ownerEmail, coOwnerEmail) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventName = eventName;
  payload.ownerEmail = ownerEmail;
  payload.coOwnerEmail = coOwnerEmail;
  return commonUtil.triggerServerRequest({ url: GETVALIDATEEVENTNAMEURL, method: 'POST', data: payload });
}
